module.exports = __webpack_public_path__ + "img/topBack-satifaction.09170931.png";